import type { Brand } from '@/lib/brand';
import conectaSymbol from '@/assets/brand/prime-conecta-symbol.svg';
import primeLogo from '@/assets/brand/prime-telefonia-cropped-dark.png';
import { cn } from '@/lib/utils';

export function BrandSymbol({ brand, className }: { brand: Brand; className?: string }) {
  return (
    <span className={cn('relative inline-block h-6 w-6 shrink-0 overflow-hidden', className)} aria-hidden="true">
      {brand === 'prime-conecta' ? (
        <img src={conectaSymbol} alt="" className="h-full w-full object-contain" />
      ) : (
        <img src={primeLogo} alt="" className="absolute left-0 top-0 h-full w-auto max-w-none" />
      )}
    </span>
  );
}
